// extracted by mini-css-extract-plugin
export default {"photo":"IngredientesPhoto_photo__LQ4R2","placeholder":"IngredientesPhoto_placeholder__ELtYT","photo_min":"IngredientesPhoto_photo_min__h796C"};